import { render, staticRenderFns } from "./customer-escrow-sugar.vue?vue&type=template&id=d04db302&"
import script from "./customer-escrow-sugar.vue?vue&type=script&lang=js&"
export * from "./customer-escrow-sugar.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports